import { Tabs } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledTabs = styled(Tabs)({
  backgroundColor: '#fff',
});
